// extracted by mini-css-extract-plugin
module.exports = {"CardWrapper":"Card_CardWrapper__1PnFk","CardContent":"Card_CardContent__1g631","selected":"Card_selected__12pIR"};